import { styled } from "styled-components";

export const Screen = styled.div``;

export const Inner = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const ImageCol = styled.div<{ src: string }>`
  background-image: url(${(props) => props.src});
  background-position: right;
  background-size: cover;
  height: 100dvh;
`;

export const TextCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100dvh;
`;

export const TextColInner = styled.div`
  display: flex;
  flex-direction: column;
  width: 410px;
`;

export const SubTitle = styled.h1`
  font-size: 14px;
  font-weight: 700;
  padding-bottom: ${({ theme }) => theme.spacing[1]};
`;

export const Title = styled.h1`
  font-size: 36px;
  font-weight: 700;
  padding-bottom: ${({ theme }) => theme.spacing[3]};
`;

export const Description = styled.h1`
  font-size: 18px;
  padding-bottom: ${({ theme }) => theme.spacing[6]};
`;